import { useControl } from 'react-map-gl/maplibre';

class StyleSwapControl {
    constructor(options) {
        this._options = options;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement('div');
        this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';

        this._button = document.createElement('button');
        this._button.className = 'mapboxgl-ctrl-icon';
        this._button.type = 'button';
        this._button.onclick = this._options.onClick;

        this._iconContainer = document.createElement('span');
        this._iconContainer.className = 'mapboxgl-ctrl-icon';
        this._iconContainer.setAttribute('aria-hidden', 'true');
        this._iconContainer.innerHTML = this._options.iconSvg;

        this._button.appendChild(this._iconContainer);
        this._container.appendChild(this._button);

        this.update(this._options);

        return this._container;
    }

    update(options) {
        this._options = options;
        if (this._button) {
            this._button.title = options.title;
            this._button.setAttribute('aria-label', options.title);
        }
        if (this._iconContainer) {
            this._iconContainer.innerHTML = options.iconSvg;
        }
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}

export default StyleSwapControl;
